import dispatcher from "../Dispatcher";
import actionTypes from "./ActionTypes";
import axios from "axios";
import * as Globals from "../Globals";
import { Logout } from "./LoginActions";
import { PostAlert } from "./AlertActions";
export function AddPremiumAIGenericField(newField) {
  axios.post(`${Globals.baseUrl}/PremiumAI/AddPremiumAIGenericField`, newField, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.AddPremiumAIGenericField,
        Result: res.data
      });
      PostAlert("success", "AI Field added");
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      Logout();
    } else {
      PostAlert("error", "Unable to add AI field");
      console.log("Request failed:", error);
    }
  });
}
export function DeletePremiumAIGenericField(id) {
  axios.delete(`${Globals.baseUrl}/PremiumAI/DeletePremiumAIGenericField/${id}`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.DeletePremiumAIGenericField
      });
      PostAlert("success", "AI Field deleted");
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      Logout();
    } else {
      PostAlert("error", "Unable to delete AI field");
      console.log("Request failed:", error);
    }
  });
}
export function UpdatePremiumAIFields(payload) {
  axios.post(`${Globals.baseUrl}/PremiumAI/UpdatePremiumAIFields`, payload, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.UpdatePremiumAIFields
      });
      PostAlert("success", "AI Field updated");
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      Logout();
    } else {
      PostAlert("error", "Unable to update AI field");
      console.log("Request failed:", error);
    }
  });
}
export function GetPremiumAIFields(genericFieldId) {
  axios.get(`${Globals.baseUrl}/PremiumAI/GetPremiumAIFields/${genericFieldId}`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.GetPremiumAIFields,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetCurrentMonthRequestCount() {
  axios.get(`${Globals.baseUrl}/PremiumAI/GetCurrentMonthRequestCount`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.GetPremiumAICurrentMonthRequestCount,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetPremiumAIGenericFields() {
  axios.get(`${Globals.baseUrl}/PremiumAI/GetPremiumAIGenericFields`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    console.log("retrurnable");
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.GetPremiumAIGenericFields,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
